import {scrollToElement} from "../helpers/dom/scroll";
import {findClosestElementByClass} from "../helpers/dom/closest";
import {getParameterByName} from '../helpers/getParameter';
import {setParameter} from '../helpers/setParameter';

export const productChoice = {
  activate : function () {
    const products = document.querySelectorAll(".product-choice");
    let filterContainer = document.querySelector(".filterContainer");
    const filtersUrl = getParameterByName('filter');

    if(filtersUrl) {
      var filterArr = filtersUrl.split(',')     

      for (let f of filterArr) {
        let singleFilter = document.querySelector('[data-package="' + f + '"]')
        singleFilter.classList.add("active");          
      }

      productChoice.filter();
    } else {
      productChoice.setAlternateClasses(filterContainer);
    }
    
    
  
    products.forEach( (el) => {
      el.addEventListener('click', () => el.classList.toggle('active') );        
      el.addEventListener('click', productChoice.filter );
    })
    
    
  },

  filter: function () {
    const filterContainers = document.querySelectorAll(".filterContainer");

    filterContainers.forEach( (container) => {
      let filterValues = Array.prototype.slice.call(container.querySelectorAll(".product-choice.active")).map(x => x.getAttribute("data-package"));          
      
      window.history.pushState('', '', setParameter('filter', filterValues))
      
      const allPackages = container.querySelectorAll(".packages-list");

      allPackages.forEach( (singlePackage) => {
        let packageValue = singlePackage.getAttribute("data-package").split(";");
        if (filterValues.some(val => packageValue.indexOf(val) === -1)) {
          singlePackage.classList.remove("visiblePackage");
          singlePackage.style.display = "none";
        }
        else {
          singlePackage.classList.add("visiblePackage");
        }
      })

      const button = container.querySelector(".morePackages");
      let visibleItemsNumber = button.getAttribute("data-visible");
      productChoice.setVisiblePackages(container, visibleItemsNumber, button);
      productChoice.showHideNoPackagesInfo(container);
      productChoice.setAlternateClasses(container);
    })
  },

  setVisiblePackages: function (container, dataVisible, button) {
    let packages = container.querySelectorAll(".packages-list.visiblePackage");
    packages.forEach((p, i) => {
      if(i >= dataVisible) {
        p.style.display = "none";
      }
      else {
        p.style.display = "block";
      }
    });
    productChoice.showHideButton(button, dataVisible, packages);
  },

  initPackagesNumber: function() {
    const filterContainers = document.querySelectorAll(".filterContainer");
    filterContainers.forEach( (container) => {
      const button = container.querySelector(".morePackages");
      let numberOfPackages = button.getAttribute("data-visible");
      productChoice.setVisiblePackages(container, numberOfPackages, button);
    })
  },

  showMorePackages: function () {
    const buttons = document.querySelectorAll(".morePackages");

    buttons.forEach( (button) => {
      button.addEventListener('click', function() {
        let visible = this.getAttribute("data-visible");
        const more = this.getAttribute("data-more");
        let number = parseInt(visible) + parseInt(more);
        const parentContainer = findClosestElementByClass(button, "filterContainer");
        let visiblePackagesNumber = parentContainer.querySelectorAll(".packages-list.visiblePackage").length;
        number = (number > visiblePackagesNumber)?visiblePackagesNumber:number;
        this.setAttribute("data-visible", number);
        productChoice.setVisiblePackages(parentContainer, number, this);
        productChoice.setAlternateClasses(parentContainer);
      })
    })
  },

  showHideButton: function(button, dataVisible, visiblePackages) {
    let numberOfPackages = visiblePackages.length;
    if (dataVisible < numberOfPackages) {
      button.style.display = "inline-block";
    }
    else {
      button.style.display = "none";
    }
  },

  showHideNoPackagesInfo: function(container) {
    const info = container.querySelector(".packages-list__no-packages");
    if (container.querySelectorAll(".packages-list.visiblePackage").length == 0) {
      info.style.display = "block";
    }
    else {
      info.style.display = "none";
    }
  },

  scrollToContact: function() {
    const scrollToContact = document.querySelectorAll(".scrollToContact");
    scrollToContact.forEach( el => {
      el.addEventListener("click", function() {
        scrollToElement(".contact-box", 125, 500);
      })
    })
  },

  setAlternateClasses: function(container) {    
    container.querySelectorAll(".visiblePackage").forEach((singlePackage, index) => {
      if(index % 2 == 0) {
        singlePackage.classList.remove("packages-list--white");
        singlePackage.classList.add("packages-list--gray");
      }
      else {
        singlePackage.classList.remove("packages-list--gray");
        singlePackage.classList.add("packages-list--white");
      }
    });
  }

}
